import styled, { css } from 'styled-components';
import Icon from '@minecraft.icon';
import { media } from '@minecraft.themes';

export const DrawerNavigationContainer = styled.div`
  height: 100%;
  overflow-y: auto;

  ${media.sm`
    width: 50%;
  `}

  ${media.sm`
    border-right: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  `}
`;

export const DrawerNavigationAdditionalControls = styled.div`
  margin-top: 1rem;
`;

export const DrawerNavigationSectionTitle = styled.div`
  align-items: center;
  display: flex;
  font-weight: 500;
  margin: 1.25rem 0;

  &:first-child {
    margin-top: 0;
  }

  &:after {
    background-color: ${(props): string => props.theme.colors.primary.ltGrey1};
    content: '';
    flex: auto;
    height: 1px;
    margin-left: 0.625rem;
  }
`;

export const DrawerNavigationCategoryButton = styled.button<{ $isActive: boolean; $isActiveWithSelection: boolean }>`
  align-items: center;
  background-color: ${(props): string => props.theme.colors.accent.ltBlue2};
  display: flex;
  cursor: pointer;
  font-weight: 500;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  margin-bottom: 0.5rem;
  text-align: left;
  justify-content: space-between;
  width: 100%;

  &,
  &:focus,
  &:active,
  &:hover {
    outline: none;
    box-shadow: none;
    border: none;
  }

  &:focus {
    box-shadow: 0px 0px 0px 0.25rem #cae7f7;
  }

  ${(props) => css`
    &&& {
      ${props.$isActive &&
      `
        background-color: ${props.theme.colors.accent.ltGrey2};
        border: 0.0625rem solid ${props.theme.colors.primary.grey3};
      `}

      ${props.$isActiveWithSelection &&
      `
        font-weight: 700;
      `}

      ${!props.$isActive &&
      props.$isActiveWithSelection &&
      `
        background-color: ${props.theme.colors.accent.greyBlue2};
        border: 0.0625rem solid ${props.theme.colors.primary.ltGrey1};
        font-weight: 700;
      `}
    }
  `}

  &&&:hover {
    background-color: ${(props): string => props.theme.colors.accent.greyBlue1};
  }
`;

export const ChevronIcon = styled(Icon)`
  margin-left: 0.625rem;
  transform: rotate(90deg);
  height: 1.125rem;
  width: 1.125rem;
`;
